export default "__VITE_ASSET__CUX2YM_h__"